import { useMutation } from '@tanstack/react-query'
import { UseBaseMutationOptions } from '@/core/api/type'
import { MessagingMutationKey } from '../../keys'
import MessagingService from '../services'
import {
	CreateMessageTransactionRequest,
	GetAutoMessageResponse,
} from '../../types'

function useMutationCreateAutoMessage(
	props?: UseBaseMutationOptions<
		GetAutoMessageResponse,
		CreateMessageTransactionRequest
	>,
) {
	return useMutation({
		mutationKey: [MessagingMutationKey.CreateAutoMessageTransaction],
		mutationFn: (data: CreateMessageTransactionRequest) =>
			MessagingService.createAutoMessageTransaction(data),
		...props,
	})
}

export default useMutationCreateAutoMessage
